// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nodedz.46.225.108.6.bkend.io";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzg0NTYxNDc4LCJleHAiOjE5NDIyNDE0Nzh9.okxwCMVGlqlDv5JnftDCGaM-uIJ6qJ3PZccL7vuxLcU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: (url, options = {}) => {
      return fetch(url, {
        ...options,
        signal: AbortSignal.timeout(60000) // Timeout de 60s pour requêtes lourdes
      });
    }
  }
});

// 🔥 FORCE SESSION REFRESH ON STARTUP
supabase.auth.getSession().then(({ data: { session }, error }) => {
  if (error) {
    console.error('❌ [SESSION ERROR]', error);
  }
  
  if (session) {
    const expiresAt = new Date(session.expires_at! * 1000);
    const now = new Date();
    const timeLeft = (expiresAt.getTime() - now.getTime()) / 1000 / 60;
    
    console.log('🔐 [INITIAL SESSION]', {
      userId: session.user.id,
      expiresAt: expiresAt.toISOString(),
      timeLeft: timeLeft.toFixed(2) + ' minutes'
    });
    
    // If expires in less than 5 minutes, force refresh
    if (timeLeft < 5) {
      console.warn('⚠️ [SESSION EXPIRING SOON] - Refreshing');
      supabase.auth.refreshSession();
    }
  } else {
    console.warn('⚠️ [NO SESSION] - User needs to login');
  }
});